/**
 * @generated SignedSource<<42e5f8b5712d1db207c54b9bb3ceed05>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignSeriesCreatorCollection_iconicDesignSeriesPage$data = {
  readonly primaryCreator: {
    readonly cmsTopModule: {
      readonly description: string | null;
    } | null;
    readonly designs: ReadonlyArray<{
      readonly displayName: string | null;
      readonly linkData: {
        readonly isLinkable: boolean | null;
      };
      readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesCollectionItem_design">;
    } | null> | null;
    readonly displayName: string | null;
  } | null;
  readonly " $fragmentType": "DesignSeriesCreatorCollection_iconicDesignSeriesPage";
};
export type DesignSeriesCreatorCollection_iconicDesignSeriesPage$key = {
  readonly " $data"?: DesignSeriesCreatorCollection_iconicDesignSeriesPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesCreatorCollection_iconicDesignSeriesPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "primaryCreatorDesignsMaxCount"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignSeriesCreatorCollection_iconicDesignSeriesPage",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "maxDesignsCount",
          "variableName": "primaryCreatorDesignsMaxCount"
        }
      ],
      "concreteType": "PrimaryCreatorForSeries",
      "kind": "LinkedField",
      "name": "primaryCreator",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "IconicDesignSeriesCmsTopModule",
          "kind": "LinkedField",
          "name": "cmsTopModule",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IconicDesignSeriesItem",
          "kind": "LinkedField",
          "name": "designs",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isLinkable",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DesignSeriesCollectionItem_design"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IconicDesignSeriesPage",
  "abstractKey": null
};
})();

(node as any).hash = "989a40da002833e4203b9085b831ad23";

export default node;
